import { DateComponent } from "./Date-Component";
export class DateValue {
   date: DateComponent;
}
